import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LanguageSwitcher } from '../LanguageSwitcher';
import styles from './jotpa.module.css';
export function Header({ title }) {
    return (_jsxs("header", { children: [_jsxs("div", { className: "header", children: [_jsx("div", { children: _jsx("img", { className: styles.jotpaLogo, src: "/jotpa_logo.png", alt: "" }) }), _jsx(LanguageSwitcher, {})] }), _jsx("div", { className: "content", children: _jsx("h1", { children: title }) })] }));
}
